import React, { useEffect, useState } from "react";
import { ModalProps } from "Components/ReactstrapSlim";
import { VerificationPopUp } from "../Components";
import CheckIcon from "./CheckIcon";
import { useApiClient } from "Services/API/useApiClient";
import { VenueClaimClient } from "Services/API/API";

import classes from "./VerifiedEmailPopUp.module.scss";

const VERIFIED_QUERY_PARAM = "cypemailverify";

const getTicketIdFromURL = () => {
   const queryParams = new URLSearchParams(window.location.search);
   const ticketId = queryParams.get(VERIFIED_QUERY_PARAM);

   return ticketId && parseFloat(ticketId);
};

export interface VerifiedEmailPopUpProps extends ModalProps {
   toggle?: () => void;
   venueId: Guid;
}

const VerifiedEmailPopUp: React.FC<VerifiedEmailPopUpProps> = ({ venueId, ...props }) => {
   const [isOpen, setIsOpen] = useState(false);
   const venueClaimClient = useApiClient(VenueClaimClient);

   const toggle = () => {
      setIsOpen((s) => !s);
      const queryParams = new URLSearchParams(window.location.search);
      if (queryParams.has(VERIFIED_QUERY_PARAM)) {
         queryParams.delete(VERIFIED_QUERY_PARAM);
         history.replaceState("", "", "?" + queryParams.toString());
      }
   };

   useEffect(() => {
      const verify = async () => {
         const ticketId = getTicketIdFromURL();
         if (ticketId) {
            await venueClaimClient.verifyHost(venueId, ticketId)
            setIsOpen(true)
         }
      }
      verify();
   }, []);

   return (
      <VerificationPopUp
         isOpen={isOpen}
         toggle={toggle}
         title="Your email has been verified"
         actionText="Go it"
         icon={<CheckIcon />}
         {...props}
      >
         <div className={classes.descriptionContainer}>
            Our team will contact you shortly via email about the next steps.
         </div>
      </VerificationPopUp>
   );
};

export default VerifiedEmailPopUp;
